import { Survey } from '@domains';
import { Action, createReducer, on } from '@ngrx/store';

import * as fromActions from './survey.actions';

export interface SurveyState {
  surveys: Array<Survey>;
  surveysTotalCount: number;
  survey: Survey;
  createdSurvey: Survey;
  updatedSurvey: Survey;
  deletedSurveyId: number;
}

const initialState: SurveyState = {
  surveys: new Array<Survey>(),
  surveysTotalCount: 0,
  survey: undefined,
  createdSurvey: undefined,
  updatedSurvey: undefined,
  deletedSurveyId: 0,
};

const reducer = createReducer(
  initialState,

  on(fromActions.getSurveys, (state) => {
    return { ...state, surveysTotalCount: 0, surveys: [] };
  }),
  on(fromActions.getSurveysSuccess, (state, { resultsCount, results }) => ({
    ...state,
    surveysTotalCount: resultsCount,
    surveys: results,
  })),
  on(fromActions.clearSurveysFindParams, (state) => {
    return { ...state };
  }),

  on(fromActions.clearSurvey, (state) => ({ ...state, survey: null })),
  on(fromActions.getSurvey, (state) => ({ ...state, survey: null })),
  on(fromActions.getSurveySuccess, (state, action: any) => ({ ...state, survey: action.survey })),

  on(fromActions.createSurveySuccess, (state, action: any) => ({ ...state, createdSurvey: action.survey })),

  on(fromActions.updateSurveySuccess, (state, action: any) => ({ ...state, updatedSurvey: action.survey })),

  on(fromActions.deleteSurveySuccess, (state, action: any) => ({ ...state, deletedSurveyId: action.surveyId })),
);

export function surveyReducer(state: SurveyState | undefined, action: Action) {
  return reducer(state, action);
}
